function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */

if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};
class ScrollTo extends HTMLElement {

  constructor() {
    super();
    this.listeners();
    this.mq = window.matchMedia('(max-width: 979px)');
  }

  listeners() {
    this.addEventListener('click', (e) => {
      let target = this.getAttribute('data-target');
      const mobileTarget = this.getAttribute('data-target-mobile');
      const tab = this.getAttribute('data-tab');

      if (this.mq.matches && mobileTarget) {
        target = mobileTarget;
      }

      if (tab) {
        document.dispatchEvent(
          new CustomEvent('tab:show', {
            detail: {
              data: {
                tab: tab
              }
            }
          })
        )
      }

      if (target) {
        const targetElement = document.querySelector(target);

        if (targetElement) {
          let headerHeight = 0;

          const header = document.querySelector('.js-site-header');
          const targetPosition = targetElement.getBoundingClientRect().top;

          if (header) {
            headerHeight = header.offsetHeight;
          }

          const scrollTarget = targetPosition + window.pageYOffset - headerHeight;

          window.scrollTo({
            top: scrollTarget,
            behavior: "smooth"
          });
        }
      }

      e.preventDefault();
    });
  }
}

customElements.define('scroll-to', ScrollTo);

class QtySelect extends HTMLElement {

  constructor() {
    super();
    this.listeners();
  }

  listeners() {
    let timeout;
    const input = this.querySelector('[data-qty-select-input]');
    const plus = this.querySelector('[data-qty-select-plus]');
    const minus = this.querySelector('[data-qty-select-minus]');
    const min = parseInt(input.getAttribute('min')) || 0;
    const max = parseInt(input.getAttribute('max')) || 99;
    const key = this.getAttribute('data-cart-item-key') ? this.getAttribute('data-cart-item-key') : '';
    const staticBundle = this.getAttribute('data-static-bundle-qty-select');
    const qty = parseInt(this.getAttribute('data-quantity'));

    plus.addEventListener('click', function () {
      const currentQty = parseInt(input.value) || 1;

      if (staticBundle) {
        input.value = currentQty + 1;

        dispatchStaticBundleQtyChange(input);
      } else {
        if (currentQty < max) {
          input.value = currentQty + 1;

          dispatchQtyChange(key, input);
        }
      }
    });

    minus.addEventListener('click', function () {
      const currentQty = parseInt(input.value) || 1;

      if (staticBundle) {
        input.value = currentQty - 1;

        dispatchStaticBundleQtyChange(input);
      } else {
        if (currentQty > min) {
          input.value = currentQty - 1;

          dispatchQtyChange(key, input);
        }
      }
    });

    input.addEventListener('change', qtyChange);

    // input.addEventListener('keydown', function(e) {
    //   if (e.key === 'Enter') {
    //     input.removeEventListener('change', qtyChange);
    //     qtyChange();
    //   }
    // });

    function qtyChange() {
      const currentQty = parseInt(input.value);

      if (isNaN(currentQty) || currentQty < min || currentQty > max) {
        input.value = 1;
      }

      dispatchQtyChange(key, input);
    }

    function dispatchQtyChange(key, input) {
      if (key) {
        if (timeout) {
          clearTimeout(timeout);
        }

        timeout = setTimeout(function () {
          document.dispatchEvent(
            new CustomEvent('qty:change', {
              detail: {
                key: key,
                quantity: input.value
              }
            })
          );
        }, 300);
      }
    }

    function dispatchStaticBundleQtyChange(input) {
      document.dispatchEvent(
        new CustomEvent('staticBundleQty:change', {
          detail: {
            quantity: input.value
          }
        })
      );
    }

    document.addEventListener('cart:requestError', () => {
      if (qty && !isNaN(qty)) input.value = qty;
    });
  }
}

customElements.define('qty-select', QtySelect);


class QtyDropdown extends HTMLElement {

  constructor() {
    super();
    this.listeners();
  }

  listeners() {
    const select = this.querySelector('.js-qty-dropdown-select');
    const key = this.getAttribute('data-cart-item-key') ? this.getAttribute('data-cart-item-key') : '';

    if(!select) return;

    const qty = parseInt(this.getAttribute('data-quantity'));

    select.addEventListener('change', qtyChange);

    function qtyChange() {
      const currentQty = parseInt(select.value);

      if (isNaN(currentQty)) {
        select.value = 1;
      }

      select.blur();

      dispatchQtyChange(key, select);
    }

    function dispatchQtyChange(key, select) {
      if (key) {
        document.dispatchEvent(
          new CustomEvent('qty:change', {
            detail: {
              key: key,
              quantity: select.value
            }
          })
        );
      }
    }

    document.addEventListener('cart:requestError', () => {
      if(qty && !isNaN(qty)) select.value = qty;
    });
  }
}

customElements.define('qty-dropdown', QtyDropdown);

class CartRemove extends HTMLElement {

  constructor() {
    super();
    this.listeners();
  }

  listeners() {
    const key = this.getAttribute('data-item-key');
    const multiple = this.getAttribute('data-multiple');

    if (key) {
      this.addEventListener('click', () => {
        document.dispatchEvent(
          new CustomEvent('cart:remove', {
            detail: {
              key: key,
              multiple: multiple
            }
          })
        );
      });
    }
  }
}

customElements.define('cart-remove', CartRemove);

// SHARE BUTTON

class ShareButton extends HTMLElement {

  constructor() {
    super();
    this.listeners();
  }

  listeners() {
    if (typeof navigator.share === 'function') {

      const shareData = {
        title: this.getAttribute('data-share-title'),
        text: this.getAttribute('data-share-text'),
        url: location.href
      }

      this.classList.remove('share-button--hidden');

      document.addEventListener('url:change', (e) => {
        if (e.detail.url) {
          shareData.url = e.detail.url;
        }
      });

      this.addEventListener('click', async () => {
        try {
          await navigator.share(shareData);
        } catch(error) {
          console.error(error);
        }
      });
    }
  }
}

customElements.define('share-button', ShareButton);

//TABS

class SiteTabs extends HTMLElement {

  constructor() {
    super();
    this.init();

    document.addEventListener('fakeVariant:loaded', () => {
      this.init();
    });
  }

  init() {
    this.mq = window.matchMedia('(max-width: 979px)');
    this.details = this.getAttribute('data-details') === 'true';

    if (!this.details) {
      this.resizeChecker(this.mq);
      this.mq.addListener(this.resizeChecker.bind(this));
    }

    this.listeners();
  }

  listeners() {
    const self = this;
    const tabLinks = this.querySelectorAll('.js-tabs-link');

    tabLinks.forEach((tabLink) => {
      tabLink.addEventListener('click', (e) => {
        const targetId = tabLink.getAttribute('data-tab');

        e.preventDefault();

        if (targetId) {
          this.showTab(targetId, tabLink);
        }
      })
    });

    document.addEventListener('tab:show', (e) => {
      const targetId = e.detail.data.tab;
      let tabLink;

      if (targetId) {

        if (self.mq.matches) {
          tabLink = self.querySelector(`.js-tabs-link-mobile[data-tab="${targetId}"]`);
        } else {
          tabLink = self.querySelector(`.js-tabs-link-desktop[data-tab="${targetId}"]`);
        }

        if (tabLink) {
          this.showTab(targetId, tabLink, true);
        }
      }
    });
  }

  showTab(targetId, tabLink, showOnly) {
    const self = this;
    const tabs = this.querySelectorAll('.js-tabs-content');
    const targetTab = document.querySelector(targetId);
    const tabLinks = this.querySelectorAll('.js-tabs-link');

    if (targetTab) {
      const otherTabLinks = [...tabLinks].filter((otherTabLink) => otherTabLink !== tabLink);
      const otherTabs = [...tabs].filter((otherTab) => otherTab !== targetTab)

      otherTabLinks.forEach((otherTabLinks) => {
        otherTabLinks.classList.remove('active');

        if (otherTabLinks.getAttribute('data-tab') === targetId) {
          otherTabLinks.classList.remove('active');
        }
      });

      otherTabs.forEach((otherTab) => {
        otherTab.classList.remove('active');
      });
    }

    if (!showOnly && (self.mq.matches || this.details)) {
      tabLink.classList.toggle('active');
      targetTab.classList.toggle('active');
    } else {
      tabLink.classList.add('active');
      targetTab.classList.add('active');
    }
  }

  resizeChecker(mq) {
    let active = false;
    const keepOpen = this.getAttribute('data-keep-open');

    if (keepOpen) {
      return;
    }

    const tabLinks = this.querySelectorAll('.js-tabs-link');
    const tabs = this.querySelectorAll('.js-tabs-content');

    if (mq.matches) {
      tabLinks.forEach((tabLink) => {
        tabLink.classList.remove('active')
      });

      tabs.forEach((tab) => {
        tab.classList.remove('active')
      });
    } else {
      tabs.forEach((tab) => {
        if (tab.classList.contains('active')) {
          const tabId = tab.id;

          tabLinks.forEach((tabLink) => {
            if (tabLink.getAttribute('data-tab') === `#${tabId}`) {
              tabLink.classList.add('active');
            }
          });

          active = true;
          return;
        }
      });

      if (!active) {
        const firstTabLink = tabLinks[0];
         const firstTabId = firstTabLink ? firstTabLink.getAttribute('data-tab') : null;
        const firstTab = firstTabId ? document.querySelector(firstTabId) : null;

        tabLinks.forEach((tabLink) => {
          if (tabLink.getAttribute('data-tab') === firstTabId) {
            tabLink.classList.add('active');
          }
        });

        if (firstTab) {
          firstTab.classList.add('active');
        }
      }
    }
  }
}

customElements.define('site-tabs', SiteTabs);

// DETAILS

class SiteDetails extends HTMLElement {

  constructor() {
    super();
    this.mq = window.matchMedia('(max-width: 767px)');
    this.listeners();
  }

  listeners() {
    const detailsTitles = this.querySelectorAll('.js-details-title');

    detailsTitles.forEach((el) => {
      el.addEventListener('click', () => {
        this.detailsClickEvent(el);
      })
    });

    this.resizeChecker(this.mq);
    this.mq.addListener(this.resizeChecker.bind(this));
  }

  resizeChecker(mq) {
    const mobileOnly = this.getAttribute('data-mobile-only') == 'true' ? true : false;
    const openFirst = this.getAttribute('data-open-first') == 'true' ? true : false;

    if (mobileOnly) {
      const detailsItems = this.querySelectorAll('.js-details-item');

      if (mq.matches) {
        detailsItems.forEach((el) => {
          el.classList.remove('is-active');
        });

        if (openFirst) {
          detailsItems[0].classList.add('is-active');
        }
      } else {
        detailsItems.forEach((el) => {
          el.classList.add('is-active');
        });
      }
    }
  }

  detailsClickEvent(el) {
    const id = el.getAttribute('data-toggles');
    const detailsContainer = this;
    const detailsItem = detailsContainer.querySelector(`#${id}`);
    const mobileOnly = detailsContainer.getAttribute('data-mobile-only') == 'true' ? true : false;

    if (mobileOnly) {
      if (this.mq.matches) {
        this.toggleStates(detailsContainer, detailsItem);
      }
    } else {
      this.toggleStates(detailsContainer, detailsItem);
    }
  }

  toggleStates(container, item) {
    let detailsItem = item;
    let detailsItems = container.querySelectorAll('.js-details-item');
    let autoClose = container.getAttribute('data-auto-close') == 'true' ? true : false;

    if (!detailsItem.classList.contains('is-active')) {

      if (autoClose === true) {
        detailsItems.forEach(el => {
          el.classList.contains('is-active') ? el.classList.remove('is-active') : null;
        });
      }

      detailsItem.classList.add('is-active');

    } else {
      detailsItem.classList.remove('is-active');
    }
  }
}

customElements.define('site-details', SiteDetails);

// READ MORE
class ReadMore extends HTMLElement {

  constructor() {
    super();
    this.listeners();
  }

  listeners() {
    const toggle = this.querySelector('.js-read-more-toggle');
    toggle.addEventListener('click', () => {
      this.classList.toggle('read-more--clipped');
    });
  }
}

customElements.define('read-more', ReadMore);

// PRODUCT FORM

class SiteProductForm extends HTMLElement {

  constructor() {
    super();
    this.init();
  }

  init() {
    this.form = this.querySelector('.js-product-form');
    this.fakeVariants = this.getAttribute('data-fake-variants');
    this.productCard = this.getAttribute('data-product-card') === 'true';
    this.miniProduct = this.getAttribute('data-mini-product') === 'true';
    this.options = '';
    this.index = '';
    this.variantData = '';
    this.currentVariant = '';
    this.category = '';
    this.firstLoad = true;
    this.swatchClicked = false;
    this.fakeVariantLoading = false;
    this.listeners();
  }

  listeners() {
    document.addEventListener('modalContent:ready', (e) => {
      this.category = e.detail.data.category;
      this.index = e.detail.data.index;
    });

    if (window.subscriptions.sealSubscriptions) {
      document.addEventListener('sealsubs:price_update', (e) => {
        const price = e.detail.price;
        if (price) this.updateSubscriptionPrice(Shopify.formatMoney(price, window.money.format));

        this.moveSubscriptionContainer();
      });
    }

    if (this.form) {
      const staticBundleQuantities = this.querySelectorAll('.js-static-bundle-item-quantity');

      this.addOptionEventListeners();
      this.addSwatchEventListeners();

      document.addEventListener('staticBundleQty:change', (e) => {
        this.updateStaticBundleQuantities(e, staticBundleQuantities);
      });

      if (this.getAttribute('data-product-card') && !this.fakeVariants) {
        this.onOptionChange();
      }

      this.form.addEventListener('submit', (e) => {
        e.preventDefault();

        if (this.getAttribute('data-add-to-bundle') === 'true') {
          this.addToBundle();
        } else {
          this.addToCart();
        }
      });

      if (this.fakeVariants) {
        this.getFakeVariantSwatches();

        if (!this.productCard) {
          this.getFakeVariantSelects();
        }
      }

      const recipientSend = this.form.querySelector('.js-product-form-recipient-send');
      const recipientEmail = this.form.querySelector('.js-product-form-recipient-email');

      if (recipientSend && recipientEmail) {
        const validEmail = (email) => /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g.test(email);
        const recipientEmailValidation = this.form.querySelector('.js-product-form-recipient-email-validation');
        const formSubmit = this.form.querySelectorAll('.js-product-form-submit');

        const toggleRecipientEmailValidation = (email) => {
          if (!recipientEmailValidation) return;

          if (validEmail(email)) {
            recipientEmailValidation.classList.add('hidden');

            formSubmit.forEach((el) => {
              el.removeAttribute('disabled');
            });
          } else {
            recipientEmailValidation.classList.remove('hidden');

            formSubmit.forEach((el) => {
              el.setAttribute('disabled', 'disabled');
            });
          }
        }

        const listeners = ['input', 'change', 'blur'];

        listeners.forEach((listener) => {
          recipientEmail.addEventListener(listener, () => {
            recipientSend.value = validEmail(recipientEmail.value);
            toggleRecipientEmailValidation(recipientEmail.value)
          });
        })
      }
    }
  }

  updateKlarna() {
    if (typeof window.Klarna !== 'undefined') {
      window.Klarna.OnsiteMessaging.refresh();
    }
  }

  updateShopifyPaymentButton() {
    const shopifyPaymentButton = this.querySelector('.js-shopify-payment-button');

    if (shopifyPaymentButton && Shopify.PaymentButton) {
      Shopify.PaymentButton.init()
    }
  }

  addOptionEventListeners() {
    this.form.addEventListener('change', (e) => {
      let loadFakeVariantContent = false;
      const selectedOption = e.target.options ? e.target.options[e.target.selectedIndex] : null;

      if (selectedOption) {
        const variantUrl = selectedOption.getAttribute('data-fake-variant-url');
        const variantSectionUrl = selectedOption.getAttribute('data-fake-variant-section-url');
        const variantModalTitle = selectedOption.getAttribute('data-modal-title');
        const variantModalUrl = selectedOption.getAttribute('data-modal-url');

        if (variantUrl && variantSectionUrl) {
          window.history.replaceState({ }, '', variantUrl);

          document.dispatchEvent(
            new CustomEvent('url:change', { detail: { url: location.href }})
          );

          this.fetchFakeVariant(variantSectionUrl);
          loadFakeVariantContent = true;
        } else if (variantModalTitle && variantModalUrl) {
          let category;
          let index;
          const select = e.target;

          if (select) {
            category = select.getAttribute('data-modal-category') ?  select.getAttribute('data-modal-category') : '';
            index = select.getAttribute('data-modal-index');
          }

          document.dispatchEvent(
            new CustomEvent('modal:show', {
              detail: {
                data: {
                  title: variantModalTitle,
                  url: variantModalUrl,
                  category: category,
                  index: index
                }
              }
            })
          );

          loadFakeVariantContent = true;
        }
      }

      if (loadFakeVariantContent) return;

      this.onOptionChange();
    });
  }

  addSwatchEventListeners() {
    const optionIcons = this.querySelectorAll('.js-option-icon');
    const optionIconsValue = this.querySelector('.js-option-icons-value');
    const optionIconsSelect = this.querySelector('.js-option-icons-select');

    optionIcons.forEach((el) => {
      el.addEventListener('change', () => {
        // Mark that a swatch has been clicked
        this.swatchClicked = true;
        
        this.onOptionIconSelect(el, optionIconsValue, optionIconsSelect);

        // Hide hover image when swatch is clicked
        const hoverImage = this.querySelector('.product-card__image--hover');
        if (hoverImage) {
          hoverImage.classList.add('product-card__image--hover--hidden');
        }
      });
    });

    const fakeVariantSwatches = this.querySelectorAll('.js-fake-variant-swatch');

    fakeVariantSwatches.forEach((el) => {
      // This runs from listeners(), getFakeVariantSwatches() and getFakeVariantSelects(), so the
      // same swatch can be bound more than once. Two handlers make one click start two fetches.
      if (el.dataset.swatchBound === 'true') return;

      el.dataset.swatchBound = 'true';

      el.addEventListener('click', () => {
        // Mark that a swatch has been clicked
        this.swatchClicked = true;
        
        const variantUrl = el.getAttribute('data-fake-variant-url');
        const variantSectionUrl = el.getAttribute('data-fake-variant-section-url');

        if (!variantUrl || !variantSectionUrl) return;

        window.history.replaceState({ }, '', variantUrl);

        document.dispatchEvent(
          new CustomEvent('url:change', { detail: { url: location.href }})
        );

        this.fetchFakeVariant(variantSectionUrl);
      })
    })
  }

  fetchFakeVariant(url) {
    // Ignore a second colour request while one is in flight, or the slower response wins and the
    // highlighted swatch stops matching the product on screen.
    if (this.fakeVariantLoading) return;

    this.fakeVariantLoading = true;

    window.scrollTo(0, 0);
    document.body.classList.add('product-page-loading');

    fetch(url)
    .then((res) => res.json())
    .then((variant) => {
      const parser = new DOMParser();
      const parse = (src) => {
        return parser.parseFromString(src, 'text/html');
      }

      const productMainHtml = parse(variant['stmt-product-main']);
      const productBundleHtml = parse(variant['stmt-product-bundle']);
      const productTabsHtml = parse(variant['stmt-product-tabs']);
      const productReviewsHtml = parse(variant['stmt-product-reviews']);

      const productMainTarget = document.querySelector('.js-product-main');
      const productMainSource = productMainHtml.querySelector('.js-product-main');

      const productBundleTarget = document.querySelector('.js-product-bundle');
      const productBundleSource = productBundleHtml.querySelector('.js-product-bundle');

      const productTabsTarget = document.querySelector('.js-product-tabs');
      const productTabsSource = productTabsHtml.querySelector('.js-product-tabs');

      const productReviewsTarget = document.querySelector('.js-product-reviews');
      const productReviewsSource = productReviewsHtml.querySelector('.js-product-reviews');

      const buildSections = (target, source) => {
        if (!target || !source) return;

        target.innerHTML = source.innerHTML;
      }

      buildSections(productMainTarget, productMainSource);
      buildSections(productBundleTarget, productBundleSource);
      buildSections(productTabsTarget, productTabsSource);
      buildSections(productReviewsTarget, productReviewsSource);

      this.listeners();
      this.updateKlarna();
      this.updateShopifyPaymentButton();
      document.dispatchEvent(new CustomEvent('fakeVariant:loaded'));
      document.dispatchEvent(new CustomEvent('get-delivery-date'));
      document.body.classList.remove('product-page-loading');
      this.fakeVariantLoading = false;

      if (typeof window.SealSubs !== 'undefined' && typeof window.SealSubs.refresh === 'function') {
        window.SealSubs.refresh();
      }
    })
    .catch((error) => {
      console.error(error);
      document.body.classList.remove('product-page-loading');
      this.fakeVariantLoading = false;
    })
  }

  getFakeVariantSwatches() {
    let productUrl = this.getAttribute('data-product-url');
    let variantSwatchesTarget = this.querySelector('.js-fake-variant-swatches-target');
    const appendVariantSwatchesTarget = this.querySelector('.js-append-fake-variants-target');

    const optionsTarget = this.querySelector('.js-option-icons-select');

    if (!productUrl || !variantSwatchesTarget) return;

    if (appendVariantSwatchesTarget) {
      variantSwatchesTarget = appendVariantSwatchesTarget;
      productUrl = variantSwatchesTarget.getAttribute('data-target-product-url');
    }

    let url = `${productUrl.split('?')[0]}?section_id=stmt-fake-variant-swatches`;

    if (this.productCard) {
      url = `${productUrl.split('?')[0]}?section_id=stmt-fake-variant-swatches-product-card`;
    }

    fetch(url)
    .then((res) => res.text())
    .then((swatches) => {
      const parser = new DOMParser();
      let currentVariantName = '';
      let optionsHtml = '';
      const variantSwatchesHtml = parser.parseFromString(swatches, 'text/html');
      const variantSwatchesSource = variantSwatchesHtml.querySelector('.js-fake-variant-swatches');

      if (!variantSwatchesSource || !variantSwatchesTarget) return;

      const sourceSwatches = variantSwatchesSource.querySelectorAll('.js-fake-variant-swatch');

      if (this.productCard) {
        const sourceLoadMore = variantSwatchesSource.querySelector('.js-fake-variant-swatches-view-more');
        const currentVariant = variantSwatchesSource.querySelector('.js-fake-variant-swatches-current-variant');
        const limit = window.innerWidth < 420 ? 3 : 5;

        if (currentVariant) {
          currentVariantName = currentVariant.getAttribute('data-current-variant-name');
          variantSwatchesTarget.innerHTML = currentVariant.innerHTML;
          currentVariant.remove();
        }

        let sourceHtml = '';

        sourceSwatches.forEach((swatch) => {
          sourceHtml += `
            ${swatch.innerHTML}
          `;
        })

        variantSwatchesTarget.innerHTML += sourceHtml;

        const swatches = variantSwatchesTarget.querySelectorAll('.js-product-swatch');

        if (swatches.length > limit) {
          swatches.forEach((swatch, index) => {
            if (index >= limit) {
              swatch.remove();
            }
          });

          variantSwatchesTarget.innerHTML += `
            <div class="product-swatch product-swatch--view-more">
              ${sourceLoadMore.innerHTML}
            </div>
          `;
        }

        variantSwatchesTarget.classList.remove('product-swatches--hidden');
      } else {
        variantSwatchesTarget.innerHTML += variantSwatchesSource.innerHTML;
      }

      if (optionsTarget) {
        sourceSwatches.forEach((swatch) => {
          const name = swatch.getAttribute('data-option-name');

          if (name) {
            optionsHtml += `
              <option
                value="${name}"
                ${currentVariantName === name ? 'selected': ''}
              >
                ${name}
              </option>
            `;
          }
        })

        if (optionsHtml) {
          optionsTarget.innerHTML += optionsHtml;
        }
      }

      if (this.form) {
        if (this.productCard) {
          this.onOptionChange();
        }

        this.addSwatchEventListeners();
      }
    })
    .catch((error) => {
      console.error(error);
    })
  }

  getFakeVariantSelects() {
    let productUrl = this.getAttribute('data-product-url');
    let variantSelectsTarget = this.querySelector('.js-fake-variant-selects-target');

    if (!productUrl || !variantSelectsTarget) return;

    let url = `${productUrl}?section_id=stmt-fake-variant-selects`;

    fetch(url)
    .then((res) => res.text())
    .then((variants) => {
      const parser = new DOMParser();
      const variantSelectsHtml = parser.parseFromString(variants, 'text/html');
      const variantSelectsSource = variantSelectsHtml.querySelector('.js-fake-variant-selects');

      let doc = parser.parseFromString(variantSelectsSource.innerHTML, 'text/html');
      let options = doc.getElementsByTagName('option');

      if (!variantSelectsSource || !variantSelectsTarget) return;

      for (let i = 0; i < options.length; i++) {
        if (options[i].value !== 'Default Title') {
          variantSelectsTarget.appendChild(options[i].cloneNode(true));
        }
      }

      if (this.form) {
        this.addSwatchEventListeners();
      }
    })
    .catch((error) => {
      console.error(error);
    });
  }

  addToCart() {
    const isCartPage = window.location.pathname === routes.cart_url;
    const formData = new FormData(this.form);
    const max = this.getAttribute('data-max');
    let sections = 'stmt-popout-cart'

    if (isCartPage) {
      sections = ['stmt-cart-content', 'stmt-cart-recommended-products', 'stmt-cart-sidebar'];
    }

    this.form.classList.add('is-loading');

    document.dispatchEvent(
      new CustomEvent('cart:add', {
        detail: {
          data: { formData: formData, max: max, sections: sections }
        }
      })
    )
  }

  updateStaticBundleQuantities(e, staticBundleQuantities) {
    const quantity = e.detail.quantity;

    if (!quantity) return;

    staticBundleQuantities.forEach((el) => {
      const initialQuantity = el.getAttribute('data-initial-qty');

      if (!initialQuantity) return;

      el.value = quantity * initialQuantity;
    });
  }

  addToBundle() {
    const formData = new FormData(this.form);

    this.onOptionChange();

    document.dispatchEvent(
      new CustomEvent('bundle:addItem', {
        detail: {
          data: { formData: formData, index: this.index, currentVariant: this.currentVariant, category: this.category }
        }
      })
    )
  }

  onOptionIconSelect(el, optionIconsValue, optionIconsSelect) {
    const selectedOption = el.value;

    if (optionIconsValue) {
      optionIconsValue.innerText = selectedOption;
    }

    for (let i = 0; i < optionIconsSelect.options.length; i++) {
      if (selectedOption === optionIconsSelect.options[i].value) {
        optionIconsSelect.value = selectedOption;
      }
    }

    this.onOptionChange();
  }

  onOptionChange() {
    this.updateOptions();
    this.updateSelectedVariant();
    this.updateSlider();
    this.updateDeliveryMessaging();
  }

  updateOptions() {
    const optionSelects = this.querySelectorAll('select[name^="options["]');
    const values = Array.from(optionSelects, (select) => select.value);
    
    // Treat empty or all-empty values as no options
    if (values.length === 0 || values.every(v => v === '')) {
      this.options = [];
      return;
    }
    
    this.options = values;
  }

  updateSelectedVariant(variant, context = '') {

    if (variant) {
      this.currentVariant = variant;
    } else {
      if (!this.options || this.options.length === 0) {
        this.currentVariant = this.getVariantData()[0];
      } else {
        this.currentVariant = this.getVariantData().find((variant) =>
          variant.options.every((option, index) => this.options[index] === option)
        );
      }
    }

    if (!this.currentVariant) {
      this.variantNotFound();
      this.updateUrlNoVariant();
    } else {
      this.updateUrl();
      this.updatePrice();
      this.updateCardImage();
      this.updateAddToCart();
      this.updateVariantInput();
      this.updateAvailability();
      this.updateBadge();
      this.updateRatings();
      this.updateSubtitle();
      if (!this.miniProduct) {
        this.updateTitle();
      }
      this.updateItemModalLink();
      this.updateBabylistButton(this.currentVariant);
    }

    if (this.form.classList.contains('js-product-main-form')) {
      document.dispatchEvent(
        new CustomEvent('variant:change', {
          detail: {
            data: {
              variant: this.currentVariant
            }
          }
        })
      )
    }
  }

  updateBabylistButton(variant) {
    const babylistButton = this.querySelector('.js-babylist-button');
    if (!babylistButton) return;

    const imgSrc = variant.image?.match(/<img[^>]+src=["']([^"']+)["']/i)?.[1]; //Extracts the src value
    const currentImage = babylistButton.getAttribute('data-product-image');

    const data = {
      images: variant.image ? 'https:' + imgSrc : currentImage,
      price: (variant.price_unformatted / 100).toFixed(2),
      title: `${variant.product_title} - ${variant.title}`,
      url: window.location.origin + variant.url
    };

    babylistButton.setAttribute('href', `javascript: bl.addToRegistry(${JSON.stringify(data)})`);
  }

  updateBadge() {
    if (!this.productCard) return;
    
    const badge = this.querySelector('.js-product-card-badge');
    if (!badge) return;

    // Skip if variant data hasn't loaded yet
    const available = this.currentVariant.available;
    if (available === undefined || available === null) return;
    const isAvailable = available === true || available === 'true';
    const price = this.currentVariant.price_unformatted || 0;
    const compareAtPrice = this.currentVariant.compare_at_price_unformatted || 0;
    const wrapper = this.closest('.product-card');
    
    // Determine badge content and color
    let badgeLabel = '';
    let badgeBackground = '';
    
    // Check if out of stock (available is a string, not boolean)
    if (!isAvailable) {
      // Out of stock
      badgeLabel = variantStrings.outOfStock || 'Out of Stock';
      badgeBackground = badge.getAttribute('data-badge-oos-color');
      wrapper.classList.add('product-card--sold-out');
    } else if (compareAtPrice > price && price > 0) {
      // On sale - show savings
      const savingPercentage = this.currentVariant.savingPercentage;
      const saving = this.currentVariant.saving;
      
      if (savingPercentage) {
        badgeLabel = variantStrings.savingPercentage ? 
          variantStrings.savingPercentage.replace('[saving]', savingPercentage) : 
          `Save ${savingPercentage}%`;
        badgeBackground = badge.getAttribute('data-badge-sale-color');
      } else if (saving) {
        badgeLabel = variantStrings.savingAmount ? 
          variantStrings.savingAmount.replace('[saving]', saving) : 
          `Save ${saving}`;
        badgeBackground = badge.getAttribute('data-badge-sale-color');
      }
      wrapper.classList.remove('product-card--sold-out');
    } else if (this.currentVariant.custom_flag_label) {
      // Use custom flag from variant data
      badgeLabel = this.currentVariant.custom_flag_label;
      badgeBackground = this.currentVariant.custom_flag_color;
      wrapper.classList.remove('product-card--sold-out');
    } else if (badge.getAttribute('data-custom-flag') === 'true') {
      // Fallback to badge data attributes
      const customFlag = badge.getAttribute('data-custom-flag-label');
      const customColor = badge.getAttribute('data-custom-flag-color');

      if (customFlag) {
        badgeLabel = customFlag;
        badgeBackground = customColor;
      }
      wrapper.classList.remove('product-card--sold-out');
    } else if (badge.getAttribute('data-flag-new') === 'true') {
      badgeLabel = variantStrings.new || 'New';
      badgeBackground = badge.getAttribute('data-badge-new-color');
      wrapper.classList.remove('product-card--sold-out');

    } else if (badge.getAttribute('data-flag-bestseller') === 'true') {
      badgeLabel = variantStrings.bestSeller || 'Best Seller';
      badgeBackground = badge.getAttribute('data-badge-bestseller-color');
      wrapper.classList.remove('product-card--sold-out');
    } else {
      wrapper.classList.remove('product-card--sold-out');
    }
    
    // Update badge or hide it
    if (badgeLabel) {
      badge.textContent = badgeLabel;
      badge.style.backgroundColor = badgeBackground;
      badge.classList.remove('product-card__badge--hidden');
    } else {
      badge.classList.add('product-card__badge--hidden');
    }
  }

  moveSubscriptionContainer() {
    const actionsContainer = document.querySelector('.product-main__actions');
    const subscriptionContainer = document.querySelector('.sealsubs-target-element');

    if (!actionsContainer || !subscriptionContainer) return;

    const alreadyContained = actionsContainer.contains(subscriptionContainer);

    if (!alreadyContained) {
      actionsContainer.insertBefore(subscriptionContainer, actionsContainer.firstChild);
    }
  }

  updateTitle() {
    let titleTarget = this.querySelector('.js-product-title')

    if (this.productCard) {
      titleTarget = this.querySelector('.js-product-card-title');
    }

    let titleSource = this.currentVariant.product_title;

    if (!titleTarget || !titleSource) return;

    if (titleSource.includes(' | ') == true) {
      titleSource = titleSource.split(' | ')[0];
    }

    titleTarget.innerText = titleSource;
  }

  updateRatings() {
    const ratings = this.querySelectorAll('.js-product-card-rating');
    const currentVariantRatingsId = this.currentVariant.ratings_id;

    if (!ratings || !currentVariantRatingsId || ratings.length < 2) return;

    ratings.forEach((el) => {
      const ratingId = el.getAttribute('data-rating-id');

      el.classList.add('product-card__rating--hidden');

      if (ratingId == currentVariantRatingsId) {
        el.classList.remove('product-card__rating--hidden');
      };
    });
  }

  updateSubtitle() {
    const subtitleTarget = this.querySelector('.js-product-card-subtitle');
    const subtitleSource = this.currentVariant.subtitle;

    if (!subtitleTarget) return;

    if (!subtitleSource || subtitleTarget.dataset.showSubtitle === 'false') {
      subtitleTarget.classList.add('product-card__subtitle--hidden');
      return;
    }

    subtitleTarget.classList.remove('product-card__subtitle--hidden');
    subtitleTarget.innerHTML = subtitleSource;
  }

  updateSlider() {
    const id = this.currentVariant?.featured_image?.id;

    if (id) {
      let sliderIndex;
      let targetSlide = this.querySelector(`.site-slider [data-image-id="${id}"]`);

      if (targetSlide) {
        sliderIndex = targetSlide.getAttribute('data-image-index');
      }

      let sliders = this.querySelectorAll('.site-slider');

      if (sliderIndex && sliders.length) {
        document.dispatchEvent(new CustomEvent('slider:go', {
          detail: {
            index: sliderIndex,
            targetSliders: sliders
          }
        }))
      }
    }
  }

  updateDeliveryMessaging() {
    const deliveryMessaging = this.querySelector('.js-free-delivery-threshold-pdp h2');

    // get data free-delivery-threshold-pdp
    const freeDeliveryThresholdElement = document.querySelector('.js-free-delivery-threshold-pdp');

    if (!freeDeliveryThresholdElement) return;

    const freeDeliveryThreshold = freeDeliveryThresholdElement.getAttribute('data-free-delivery-threshold-pdp');
    const freeDeliveryUnderThresholdMessage = freeDeliveryThresholdElement.getAttribute('data-free-delivery-under-threshold-message');
    const freeDeliveryOverThresholdMessage = freeDeliveryThresholdElement.getAttribute('data-free-delivery-over-threshold-message');

    // remove £ or $ this.currentVariant.price
    const variantPrice = this.currentVariant?.price.replace(/[^0-9.-]+/g,"") * 100;

    if (deliveryMessaging) {
      if( variantPrice >= freeDeliveryThreshold ) {
        deliveryMessaging.innerHTML = freeDeliveryOverThresholdMessage;
      } else {
        deliveryMessaging.innerHTML = freeDeliveryUnderThresholdMessage;
      }
    }
  }

  updateItemModalLink() {
    const modalShow = this.querySelector('.js-bundle-modal-show');
    const url = this.currentVariant.url;

    if (!modalShow || !url) return;

    modalShow.setAttribute('data-modal-url', `${url}${ url.includes('?') ? '&' : '?' }section_id=stmt-bundle-product-details`);
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('.js-product-variants').textContent);
    return this.variantData;
  }

  updateUrl() {

    if (!this.currentVariant || this.getAttribute('data-update-url') === 'false') return;

    if (this.getAttribute('data-product-card') === 'true' && this.currentVariant.url) {
      const productLinks = this.querySelectorAll('.js-product-link');
      const path = window.location.pathname;
      const pathParts = path.split('/');

      let collectionUrl = '';

      if (path.includes('collection') && this.getAttribute('data-results-card') === 'true') {
        collectionUrl = path.replace('/' + pathParts[3], '');
      }

      if (this.productCard) {
        if (!this.firstLoad) {
          productLinks.forEach((el) => {
            el.href = this.currentVariant.url;
          })
        }
      } else {
        productLinks.forEach((el) => {
          el.href = this.currentVariant.url;
        })
      }

      const trackingLink = this.parentElement.parentElement.querySelector('.js-product-tracking-link');

      if (trackingLink) {
        trackingLink.href = this.currentVariant.url;
      }
    } else if (this.dataset.product == 'true') {
      if (window.location.pathname.includes('products') == true) {
        window.history.replaceState({}, '', `${this.form.dataset.url}?variant=${this.currentVariant.id}`);
      }

      document.dispatchEvent(
        new CustomEvent('url:change', { detail: { url: location.href } })
      );
    }

    this.firstLoad = false;
  }

  updateUrlNoVariant() {
    const productLinks = this.querySelectorAll('.js-product-link');

    if (productLinks) {
      const path = window.location.pathname;
      const pathParts = path.split('/');

      let collectionUrl = '';

      if (path.includes('collection')) {
        collectionUrl = path.replace('/' + pathParts[3], '');
      }

      productLinks.forEach((el) => {
        el.href = this.form.dataset.url;
      })
    }
  }

  updateAddToCart() {
    const addToCartPriceLabel = this.querySelector('.js-product-form-submit-price-label');
    const submit = this.querySelector('.js-product-form-submit');
    const wrapper = this.closest('.product-card');

    if (submit && this.currentVariant.available == 'false') {
      wrapper.classList.toggle('product-card--sold-out', !this.currentVariant.available);
    }

    if (addToCartPriceLabel) {
      addToCartPriceLabel.innerText = this.currentVariant.price;
    }
  }

  updateCardImage() {
    if (!this.productCard) return;

    const cardPrimaryImage = this.querySelector('.js-card-primary-image');
    const cardVariantImage = this.querySelector('.js-card-variant-image');

    if (!cardPrimaryImage || !cardVariantImage) return;

    // Don't update image until a swatch has been clicked
    if (!this.swatchClicked) {
      return;
    }

    const currentVariantImage = this.currentVariant.image;
    const currentVariantMediaType = this.currentVariant.media_type;
    
    // Get the first variant's media type (default/primary)
    const allVariants = this.getVariantData();
    const firstVariantMediaType = allVariants[0]?.media_type;
    
    // Don't swap if primary/default is a video
    if (firstVariantMediaType === 'video') {
      cardVariantImage.innerHTML = '';
      cardVariantImage.style.display = 'none';
      cardPrimaryImage.style = '';
      return;
    }

    // Update main variant image/video only if we have media to show
    if (currentVariantImage && currentVariantImage !== "") {
      cardVariantImage.innerHTML = currentVariantImage;
      cardPrimaryImage.style.display = 'none';
      cardVariantImage.style = '';
    } else {
      cardVariantImage.innerHTML = '';
      cardVariantImage.style.display = 'none';
      cardPrimaryImage.style = '';
    }
  }

  updateSubscriptionPrice(subscriptionPrice) {
    const price = this.querySelector('.js-price');
    const addToCartPriceLabel = this.querySelector('.js-product-form-submit-price-label');
    const saving = this.querySelector('.js-saving');
    const savingLabel = this.querySelectorAll('.js-product-main-images-label');

    if (price && subscriptionPrice) {
      price.innerHTML = `
        <span class="product-price">
          ${subscriptionPrice}
        </span>
      `;
    }

    if (addToCartPriceLabel && subscriptionPrice) {
      addToCartPriceLabel.innerHTML = subscriptionPrice;
    }

    if (saving) {
      saving.classList.add('product-main__price-saving--hidden');
      saving.innerHTML = '';
    }

    savingLabel.forEach((el) => {
      el.classList.add('product-label--hidden');
      el.innerHTML = '';
    })
  }

  updatePrice() {
    const price = this.querySelector('.js-price');
    const saving = this.querySelector('.js-saving');
    const savingLabel = this.querySelectorAll('.js-product-main-images-label');

    if (price && this.currentVariant && this.currentVariant.price) {  // Add null check
      let html = '';

      if (this.currentVariant.saving) {
        html = `
          <span class="product-price product-price--sale">${this.currentVariant.price}</span>
          <s class="product-price ${this.productCard ? '' : 'product-main__compare-at-price'} product-price--compare-at-price">${this.currentVariant.compare_at_price}</s>
        `
      } else {
        html = `
          <span class="product-price">
            ${this.currentVariant.price}
          </span>
        `
      }

      price.innerHTML = html;
    } else if (price && !this.currentVariant?.price) {
      console.warn('Price not available for variant:', this.currentVariant);
    }

    if (saving) {
      let html = '';

      if (this.currentVariant.saving) {
        html = `${variantStrings.saving.replace('[saving]', this.currentVariant.saving)}`
        saving.classList.remove('product-main__price-saving--hidden');
      } else {
        html = '';
        saving.classList.add('product-main__price-saving--hidden');
      }

      saving.innerHTML = html;
    }

    savingLabel.forEach((el) => {
      if (this.currentVariant.savingPercentage) {
        el.classList.remove('product-label--hidden');
        el.innerHTML = `<span class="product-label__text">${variantStrings.savingPercentage.replace('[saving]', this.currentVariant.savingPercentage)}</span>`
      } else {
        el.classList.add('product-label--hidden');
        el.innerHTML = '';
      }
    });

    this.form.setAttribute('data-variant-title', this.currentVariant.product_title);
    this.form.setAttribute('data-variant-price', this.currentVariant.price_unformatted ? this.currentVariant.price_unformatted : '');
    this.form.setAttribute('data-variant-compare-at-price', this.currentVariant.compare_at_price_unformatted ? this.currentVariant.compare_at_price_unformatted : '');
  }

  updateVariantInput() {
    const input = this.form.querySelector('input[name="id"]');
    input.value = this.currentVariant.id;
  }

  updateAvailability() {
    const available = this.currentVariant.available;
    const submit = this.querySelectorAll('.js-product-form-submit');
    const inStock = this.querySelectorAll('.js-product-form-in-stock');

    if (available || this.getAttribute('data-product-card-add-to-cart') === 'true') {
      submit.forEach((el) => {
        const label = el.querySelector('.js-product-form-submit-label');
        el.removeAttribute('disabled');

        if (label) {
          if (label.getAttribute('data-bundle-product') === 'true') {
            label.innerHTML = `${variantStrings.addToBundle}`;
          } else {
            if (label.getAttribute('data-short-label') === 'true') {
              label.innerHTML = `${variantStrings.addToCart}`;
            } else if (label.getAttribute('data-mini-product') === 'true') {
              label.innerHTML = `${variantStrings.buyNow}`;
            } else {
              label.innerHTML = `
                <span class="product-card__button-label product-card__button-label--mobile">
                  ${variantStrings.addToCart}
                </span>
                <span class="product-card__button-label product-card__button-label--desktop">
                  ${variantStrings.addToCart}
                </span>
              `;
            }
          }
        }
      });

      inStock.forEach((el) => {
        el.classList.remove('product-main__in-stock--hidden');
      });
    } else {
      submit.forEach((el) => {
        const label = el.querySelector('.js-product-form-submit-label');

        el.setAttribute('disabled', 'disabled');

        if (label) {
          label.innerText = `${variantStrings.soldOut}`;
        }
      });

      inStock.forEach((el) => {
        el.classList.add('product-main__in-stock--hidden');
      });
    }
  }

  variantNotFound() {
    const submit = this.querySelectorAll('.js-product-form-submit');
    const inStock = this.querySelectorAll('.js-product-form-in-stock');

    submit.forEach((el) => {
      const label = el.querySelector('.js-product-form-submit-label');

      if (!(this.getAttribute('data-product-card-add-to-cart') === 'true')) {
        el.setAttribute('disabled', 'disabled');
      }

      if (label) {
        label.innerText = `${variantStrings.unavailable}`;
      }
    });

    inStock.forEach((el) => {
      el.classList.add('product-main__in-stock--hidden');
    });
  }
}

customElements.define('product-form', SiteProductForm);

// Fake Variant Loader - Replaces all_products[product] as reaching limits
class FakeVariantLoader extends HTMLElement {
  constructor() {
    super();
    this.loaded = false;
  }

  connectedCallback() {
    if (this.loaded) return;
    this.loadFakeVariants();
  }

  async loadFakeVariants() {
    const productForm = this.closest('product-form');
    if (!productForm) return;

    const variantScript = productForm.querySelector('.js-product-variants');
    if (!variantScript) return;

    let variants = JSON.parse(variantScript.textContent);
    const variantsToFetch = variants.filter(v => v.fetch_required);

    if (variantsToFetch.length === 0) {
      this.loaded = true;
      return;
    }

    // Fetch each variant that needs loading
    for (const variantStub of variantsToFetch) {
      try {
        const productData = await this.fetchProductByHandle(variantStub.handle);
        
        if (productData) {
          // Find and replace the stub with real data
          const stubIndex = variants.findIndex(v => v.handle === variantStub.handle && v.fetch_required);
          
          if (stubIndex !== -1) {
            variants[stubIndex] = {
              id: productData.variant_id,
              url: productData.url,
              title: productData.title,
              subtitle: productData.subtitle,
              product_title: productData.product_title,
              has_only_default_variant: productData.has_only_default_variant,
              options: variantStub.options,
              available: productData.available,
              price: productData.price,
              price_unformatted: productData.price_unformatted,
              media_type: productData.media_type,
              image: productData.image,
              compare_at_price: productData.compare_at_price,
              compare_at_price_unformatted: productData.compare_at_price_unformatted,
              saving: productData.saving,
              savingPercentage: productData.savingPercentage,
              ...(productData.custom_flag_label && {
                custom_flag_label: productData.custom_flag_label,
                custom_flag_color: productData.custom_flag_color
              }),
              ratings_id: productData.product_id,
              wishlist: {
                empi: productData.product_id,
                epi: productData.variant_id,
                dt: productData.title,
                du: `${window.location.origin}${productData.url}`,
                ct: productData.type,
                pr: productData.price_unformatted,
                stk: productData.inventory,
                iu: productData.image_url,
                variants: [{ [productData.title]: productData.product_id }],
                ...(productData.compare_at_price_unformatted && { op: productData.compare_at_price_unformatted })
              }
            };
          }
        }
      } catch (error) {
        console.error(`Failed to fetch product ${variantStub.handle}:`, error);
      }
    }

    // Update the script tag with complete data
    variantScript.textContent = JSON.stringify(variants);
    
    // Clear cached variant data
    if (productForm.variantData) {
      productForm.variantData = null;
    }

    this.loaded = true;
    
    // Dispatch event to notify that fake variants are loaded
    document.dispatchEvent(new CustomEvent('fakeVariantsLoaded'));
  }

  async fetchProductByHandle(handle) {
    const query = `{
      productByHandle(handle: "${handle}") {
        id
        handle
        title
        availableForSale
        tags
        priceRange {
          minVariantPrice {
            amount
          }
        }
        compareAtPriceRange {
          minVariantPrice {
            amount
          }
        }
        media(first: 1) {
          edges {
            node {
              mediaContentType
              ... on Video {
                sources {
                  url
                  mimeType
                }
                previewImage {
                  url
                }
              }
              ... on MediaImage {
                image {
                  url(transform: {maxWidth: 440})
                  altText
                }
              }
            }
          }
        }
        variants(first: 1) {
          edges {
            node {
              id
              availableForSale
              quantityAvailable
              image {
                url(transform: {maxWidth: 440})
                altText
              }
            }
          }
        }
        productType
        metafield(namespace: "description", key: "subtitle") {
          value
        }
        customMetafield: metafield(namespace: "custom", key: "title") {
          value
        }
      }
    }`;

    try {
      const response = await fetch(`https://${window.Shopify.shop}/api/${window.API_VERSION || '2024-01'}/graphql.json`, {
        method: "POST",
        headers: {
          "Content-Type": "application/graphql",
          "X-Shopify-Storefront-Access-Token": window.API_ACCESS
        },
        body: query
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      
      if (data.errors) {
        console.error('GraphQL errors:', data.errors);
        return null;
      }

      const product = data.data.productByHandle;
      
      if (!product) {
        console.warn(`Product not found: ${handle}`);
        return null;
      }

      const price = parseFloat(product.priceRange.minVariantPrice.amount);
      const comparePrice = parseFloat(product.compareAtPriceRange.minVariantPrice.amount) || 0;
      const variant = product.variants.edges[0]?.node;
      
      // Extract numeric ID from Shopify's gid format
      const productId = product.id.split('/').pop();
      const variantId = variant?.id.split('/').pop();
      
      // Process custom flags from tags
      let customFlagLabel = '';
      let customFlagColor = '';
      
      if (product.tags) {
        // First pass: look for color
        for (const tag of product.tags) {
          if (tag.includes('flagColor:')) {
            customFlagColor = tag.replace('flagColor:', '');
            break;
          }
        }
        
        // Second pass: look for flag label
        for (const tag of product.tags) {
          if (tag.includes('flag:') && tag !== 'flag:new' && tag !== 'flag:bestseller') {
            const flagText = tag.replace('flag:', '');
            const words = flagText.split('_');
            customFlagLabel = words.map(word => 
              word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
            ).join(' ');
            break;
          }
        }
      }
      
      // Determine media type and generate HTML
      let mediaHtml = "";
      let mediaUrl = "";
      let mediaType = "image";
      
      // Check variant image first (highest priority)
      if (variant?.image) {
        mediaType = "image";
        mediaUrl = variant.image.url;
        mediaHtml = `<img src="${variant.image.url}" alt="${variant.image.altText || product.title}" width="440" height="440" class="product-card__image">`;
      }
      // Then check featured media (first media item)
      else if (product.media?.edges?.[0]?.node) {
        const featuredMedia = product.media.edges[0].node;
        
        if (featuredMedia.mediaContentType === 'VIDEO') {
          mediaType = "video";
          const videoSource = featuredMedia.sources?.[0];
          const posterUrl = featuredMedia.previewImage?.url || '';
          
          if (videoSource) {
            mediaUrl = videoSource.url;
            mediaHtml = `<video autoplay loop muted playsinline class="product-card__video" width="440" height="440" poster="${posterUrl}"><source src="${videoSource.url}" type="${videoSource.mimeType}"></video>`;
          }
        } else if (featuredMedia.mediaContentType === 'IMAGE') {
          mediaType = "image";
          mediaUrl = featuredMedia.image.url;
          mediaHtml = `<img src="${featuredMedia.image.url}" alt="${featuredMedia.image.altText || product.title}" width="440" height="440" class="product-card__image">`;
        }
      }
      
      return {
        product_id: productId,
        variant_id: variantId,
        url: `/products/${product.handle}`,
        title: product.title,
        subtitle: product.metafield?.value || null,
        product_title: product.customMetafield?.value || product.title,
        has_only_default_variant: product.variants.edges.length === 1,
        available: product.availableForSale,
        price: Shopify.formatMoney(price * 100, window.money.format),
        price_unformatted: Math.round(price * 100),
        media_type: mediaType,
        image: mediaHtml,
        image_url: mediaUrl,
        compare_at_price: comparePrice > 0 ? Shopify.formatMoney(comparePrice * 100, window.money.format) : "",
        compare_at_price_unformatted: comparePrice > 0 ? Math.round(comparePrice * 100) : null,
        saving: comparePrice > price ? Shopify.formatMoney((comparePrice - price) * 100, window.money.format) : null,
        savingPercentage: comparePrice > price ? Math.round(((comparePrice - price) / comparePrice) * 100) : null,
        type: product.productType,
        inventory: variant?.quantityAvailable || 0,
        ...(customFlagLabel && {
          custom_flag_label: customFlagLabel,
          custom_flag_color: customFlagColor
        })
      };
    } catch (error) {
      console.error(`Storefront API error for ${handle}:`, error);
      return null;
    }
  }

}

customElements.define('fake-variant-loader', FakeVariantLoader);

// MODAL

class SiteModal extends HTMLElement {

  constructor() {
    super();
    this.listeners();
    this.body = document.querySelector('body');
    this.titleElement = this.querySelector('.js-modal-title');
    this.contentElement = this.querySelector('.js-modal-content');
  }

  listeners() {
    const closeButtons = this.querySelectorAll('.js-modal-close');

    document.addEventListener('modal:show', (e) => {
      this.showModal(e);
    });

    document.addEventListener('modal:hide', () => {
      this.hideModal();
    });

    closeButtons.forEach((el) => {
      el.addEventListener('click', () => {
        this.hideModal();
      })
    })
  }

  showModal(e) {
    const title = e.detail.data.title;
    const url = e.detail.data.url;
    const category = e.detail.data.category;
    const index = e.detail.data.index;

    document.dispatchEvent(
      new CustomEvent('alert:clear')
    );

    if (this.titleElement) {
      this.titleElement.innerText = title;
    }

    if (this.contentElement && url) {
      this.body.classList.add('modal-loading');
      this.body.classList.add('modal-active');

      fetch(url)
        .then((response) => {
          if (!response.ok) {
            throw new Error();
          }

        return response.text();
      })
      .then((text) => {
        this.contentElement.innerHTML = text;

        const bundleFakeVariantModalShow = this.contentElement.querySelectorAll('.js-bundle-fake-variant-modal-show');
        const bundleFakeVariantSelect = this.contentElement.querySelectorAll('.js-fake-variants-select');

        [...bundleFakeVariantModalShow, ...bundleFakeVariantSelect].forEach((el) => {
          if (category) {
            el.setAttribute('data-modal-category', category);
          }

          if (index) {
            el.setAttribute('data-modal-index', index);
          }
        });

        this.body.classList.remove('modal-loading');

        document.dispatchEvent(
          new CustomEvent('modalContent:ready', {
            detail: {
              data: {
                category: category,
                index: index
              }
            }
          })
        );
      })
      .catch(() => {
        this.hideModal();
        this.contentElement.innerHTML = '';

        document.dispatchEvent(
          new CustomEvent('alert:show', {
            detail: {
              data: {
                message: `${modalStrings.error}`,
                status: 'Error'
              }
            }
          })
        );
      })
    }
  }

  hideModal() {
    this.body.classList.remove('modal-active');
    this.contentElement.innerHTML = '';
    document.dispatchEvent(new Event('modalContent:destroy'));
  }
}

customElements.define('site-modal', SiteModal);

// MODAL SHOW

class ModalShow extends HTMLElement {

  constructor() {
    super();
    this.listeners();
  }

  listeners() {
    this.addEventListener('click', () => {
      const title = this.getAttribute('data-modal-title');
      const url = this.getAttribute('data-modal-url');
      const category = this.getAttribute('data-modal-category') ?  this.getAttribute('data-modal-category') : '';
      const index = this.getAttribute('data-modal-index');

      if (title && url) {
        document.dispatchEvent(
          new CustomEvent('modal:show', {
            detail: {
              data: {
                title: title,
                url: url,
                category: category,
                index: index
              }
            }
          })
        );
      }
    });
  }
}

customElements.define('modal-show', ModalShow);

// ESTIMATED DELIVERY

class EstimatedDeliveryDate extends HTMLElement {

  constructor() {
    super();
    this.listeners();
  }

  listeners() {
    if (typeof moment !== 'undefined') {
      let daysPassed = 0;
      let extraDays = 0;
      let estimatedDeliveryDate;
      let leadTime = parseInt(this.getAttribute('data-lead-time'));
      const holidays = this.getAttribute('data-holidays').split('|');

      const isWeekendOrHoliday = (date) => {
        const dateWrapper = moment(date);
        const day = dateWrapper.day();
        let isWeekend = false;
        let isHoliday = false;

        if (day == 6 || day == 0) {
          isWeekend = true;
        }

        holidays.forEach((holiday) => {
          const holidayWrapper = moment(holiday, 'MM-DD-YYYY');

          if (dateWrapper.get('date') === holidayWrapper.get('date')) {
            isHoliday = true;
          }
        });

        return isWeekend || isHoliday;
      }

      while (daysPassed < leadTime) {
        extraDays++;

        const nextDay = moment().add(extraDays, 'd');

        if (!isWeekendOrHoliday(nextDay)) {
          estimatedDeliveryDate = nextDay;
          daysPassed++;
        }
      }

      this.innerHTML = `${estimatedDeliveryDate.format('MMMM D')}.`;
    }
  }
}

customElements.define('estimated-delivery-date', EstimatedDeliveryDate);

// CART EVENTS

class CartEvents {

  constructor() {
    this.listeners();
    this.body = document.querySelector('body');
  }

  listeners() {
    document.addEventListener('cart:add', (e) => {
      if (this.body.classList.contains('cart-loading')) return;

      this.onCartLoadStart();
      this.onCartAdd(e);
    });

    document.addEventListener('cart:remove', (e) => {
      if (this.body.classList.contains('cart-loading')) return;

      this.onCartLoadStart();
      this.onCartRemove(e);
    });

    document.addEventListener('cart:updated', () => {
      this.onCartLoadEnd();
    });

    document.addEventListener('qty:change', (e) => {
      if (this.body.classList.contains('cart-loading')) return;

      this.onCartLoadStart();
      this.onCartUpdate(e);
    });

    document.addEventListener('cartAttribute:update', (e) => {
      this.onCartAttributeUpdate(e);
    });

    document.addEventListener('cartNote:update', (e) => {
      this.onCartNoteUpdate(e);
    });
  }

  onCartAdd(e) {
    const formData = e.detail.data.formData;
    const max = parseInt(e.detail.data.max);
    const multiple = e.detail.data.multiple;
    const config = fetchConfig('javascript');
    const isCartPage = window.location.pathname === routes.cart_url;
    let id = '';
    let quantity = 1;
    let max_reached = false;

    if (!multiple) {
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      for (const pair of formData.entries()) {
        if (pair[0] === 'id') {
          id = pair[1];
        }

        if (pair[0] === 'quantity') {
          quantity = pair[1];
        }
      }
    }

    config.body = formData;

    document.dispatchEvent(
      new CustomEvent('cart:requestStart')
    );

    document.dispatchEvent(
      new CustomEvent('alert:clear')
    );

    fetch(`${routes.cart_url}.json`)
      .then((res) => {
        return res.json();
      })
      .then((cart) => {
        cart.items.forEach((item) => {
          if (item.id === parseInt(id)) {
            if (item.quantity + parseInt(quantity) > max) {
              document.dispatchEvent(
                new CustomEvent('alert:show', {
                  detail: {
                    data: {
                      message: `${cartStrings.limit.replace('[max]', max).replace('[product]', item.title)}`,
                      status: 'Error'
                    }
                  }
                })
              );
              max_reached = true;
              this.onCartLoadEnd();
            }
          }
        });

        if (!max_reached) {
          fetch(`${routes.cart_add_url}`, config)
            .then((res) => {
              if (!res.ok) {
                res.json()
                  .then((error) => {
                    let errorMessage = error.description;

                    if (error.description.email && error.message) {
                      errorMessage = error.message;
                    }

                    document.dispatchEvent(
                      new CustomEvent('alert:show', {
                        detail: {
                          data: {
                            message: `${cartStrings.error_label} ${cartStrings.error}`,
                            status: 'Error'
                          }
                        }
                      })
                    );

                    this.onCartLoadEnd();
                    throw new Error(cartStrings.error);
                  })
              } else {
                res.json()
                  .then(() => {
                    fetch(`${routes.cart_url}.json`)
                      .then((res) => {
                        return res.json();
                      })
                      .then((cart) => {
                        fetch(`/?sections=${e.detail.data.sections}`)
                          .then((res) => {
                            return res.text();
                          })
                          .then((section) => {
                            if (!isCartPage) {
                              if (window.donationsEnable && window.cartItemCount === 0) {
                                sessionStorage.setItem('showPopoutCart', 'true');
                                window.location.reload();
                                return;
                              }

                              document.dispatchEvent(
                                new CustomEvent('popout-cart:show')
                              );
                            }

                            document.dispatchEvent(
                              new CustomEvent('cart:requestComplete', {
                                detail: {
                                  data: {
                                    ...cart,
                                    sections: JSON.parse(section)
                                  }
                                }
                              })
                            )
                          })
                      })
                  })
                  .catch(() => {
                    this.onCartLoadEnd();

                    document.dispatchEvent(
                      new CustomEvent('alert:show', {
                        detail: {
                          data: {
                            message: `${cartStrings.error_label} ${cartStrings.error}`,
                            status: 'Error'
                          }
                        }
                      })
                    );
                  })
              }
            })
        }
      })
  }

  onCartRemove(e) {
    const isCartPage = window.location.pathname === routes.cart_url;
    const key = e.detail.key;
    const multiple = e.detail.multiple;
    let body;
    let sections = 'stmt-popout-cart';

    if (isCartPage) {
      sections = ['stmt-cart-content', 'stmt-cart-recommended-products', 'stmt-cart-sidebar'];
    }

    if (key) {
      if (multiple) {
        const updates = {}
        const keys = key.split('|');

        keys.forEach((key) => {
          if (key) {
            updates[key] = 0;
          }
        });

        body = JSON.stringify(
          {
            updates: updates,
            sections: sections
          }
        )

        this.cartRequest(routes.cart_update_url, body);
      } else {
        body = JSON.stringify(
          {
            id: key,
            quantity: 0,
            sections: sections
          }
        )

        this.cartRequest(routes.cart_change_url, body);
      }
    } else {
      this.onCartLoadEnd();
    }
  }

  onCartUpdate(e) {
    const isCartPage = window.location.pathname === routes.cart_url;
    const key = e.detail.key;
    const quantity = e.detail.quantity;
    let sections = 'stmt-popout-cart'

    if (isCartPage) {
      sections = ['stmt-cart-content', 'stmt-cart-recommended-products', 'stmt-cart-sidebar'];
    }

    if (key && quantity >= 0) {
      const body = JSON.stringify(
        {
          id: key,
          quantity: quantity,
          sections: sections
        }
      )

      this.cartRequest(routes.cart_change_url, body);
    } else {
      this.onCartLoadEnd();
    }
  }

  onCartAttributeUpdate(e) {
    const attribute = e.detail.data.attribute;
    const name = attribute.name;
    const value = attribute.value;
    const body = JSON.stringify(
      {
        attributes: { [name]: value }
      }
    );

    this.onCartAttributeChangeStart();

    fetch(routes.cart_update_url, { ...fetchConfig(), ...{ body } })
      .then(() => {
        this.onCartAttributeChangeEnd();
      })
  }

  onCartNoteUpdate(e) {
    const note = e.detail.data.note;
    const body = JSON.stringify(
      {
        note: note
      }
    );

    this.onCartNoteChangeStart();

    fetch(routes.cart_update_url, { ...fetchConfig(), ...{ body } })
      .then(() => {
        this.onCartNoteChangeEnd();
      })
  }

  cartRequest(route, body) {
    document.dispatchEvent(
      new CustomEvent('alert:clear')
    );

    document.dispatchEvent(
      new CustomEvent('cart:requestStart')
    )
    fetch(route, { ...fetchConfig(), ...{ body } })
      .then((res) => {
        if (!res.ok) {
          res.json()
            .then((error) => {
              document.dispatchEvent(
                new CustomEvent('alert:show', {
                  detail: {
                    data: {
                      message: `${cartStrings.error_label} ${cartStrings.error}`,
                      status: 'Error'
                    }
                  }
                })
              );

              this.onCartLoadEnd();
              document.dispatchEvent(new CustomEvent('cart:requestError'));
              throw new Error(cartStrings.error);
            })
        } else {
          res.text()
          .then((data) => {
            document.dispatchEvent(
              new CustomEvent('cart:requestComplete', {
                detail: {
                  data: JSON.parse(data)
                }
              })
            )
          })
          .catch((e) => {
            console.error(e);
            this.onCartLoadEnd();
          })
        }
      })
  }

  onCartLoadStart() {
    const body = document.querySelector('body');
    body.classList.add('cart-loading');
  }

  onCartAttributeChangeStart() {
    const body = document.querySelector('body');
    body.classList.add('cart-attribute-change');
  }

  onCartAttributeChangeEnd() {
    const body = document.querySelector('body');
    body.classList.remove('cart-attribute-change');
  }

  onCartNoteChangeStart() {
    const body = document.querySelector('body');
    body.classList.add('cart-note-change');
  }

  onCartNoteChangeEnd() {
    const body = document.querySelector('body');
    body.classList.remove('cart-note-change');
  }

  onCartLoadEnd() {
    const body = document.querySelector('body');
    const isLoading = document.querySelectorAll('.is-loading');
    const staticBundleIdentifier = document.querySelectorAll('.js-static-bundle-identifier');
    const now = Date.now();

    staticBundleIdentifier.forEach((el) => {
      let productId = el.getAttribute('data-product-id');

      if (!productId) return;

      el.value = `${productId}:${now}`;
    });

    body.classList.remove('cart-loading');

    isLoading.forEach((el) => {
      el.classList.remove('is-loading');
    })
  }
}

new CartEvents();

class Footer {

  constructor() {
    this.footer = document.querySelector('.js-footer');
    this.backToTop = document.querySelector('.js-back-to-top');
    this.listeners();
  }

  listeners() {
    this.updatePadding();

    window.addEventListener('resize', () => {
      this.updatePadding();
    });

    document.addEventListener('footer:updatePadding', () => {
      this.updatePadding();
    })
  }

  updatePadding() {
    let padding = 0;
    const stickyBars = document.querySelectorAll('.js-sticky-bar');
    const captcha = document.querySelector('.grecaptcha-badge');

    if (this.backToTop) {
      padding += this.backToTop.offsetHeight;
    }

    stickyBars.forEach((el) => {
      padding += el.offsetHeight;
    });

    if (captcha) {
      padding += captcha.offsetHeight;
    }

    if (this.footer) {
      this.footer.style.paddingBottom = `calc(2rem + ${padding}px)`;
    }
  }
}

new Footer();
class locationSelect {

  constructor() {
    this.selectDropdowns = document.querySelectorAll('.country-select');
    this.locationsPopup = document.querySelector('.locations-popup');
    this.headerCountryPicker = document.querySelector('[js-header-country-picker]');
    this.body = document.querySelector('body');
    this.listeners();
  }

  showLocationsPopup() {
    if (!this.locationsPopup) return;
    this.locationsPopup.style.display = 'flex';
    this.body.style.overflow = 'hidden';
  }

  async listeners() {
    if (this.headerCountryPicker && this.locationsPopup) {
      this.headerCountryPicker.addEventListener('click', () => {
        this.showLocationsPopup();
      });

      this.headerCountryPicker.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.showLocationsPopup();
        }
      });
    }

    if (this.selectDropdowns.length > 0) {
      this.selectDropdowns.forEach((selectDropdown) => {
        selectDropdown.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.dropdownOptions = selectDropdown.querySelectorAll('.country-select-option');

          if (selectDropdown.classList.contains('is-open')) {
            selectDropdown.classList.remove('is-open');
          } else {
            selectDropdown.classList.add('is-open');
          }
          let button = selectDropdown.parentElement.querySelector('.country-select-button');

          this.dropdownOptions.forEach((dropdownOption) => {
            dropdownOption.addEventListener('click', (e) => {

              if (!dropdownOption.classList.contains('selected')) {
                let countryCode = dropdownOption.getAttribute('data-code');
                let newURL = dropdownOption.getAttribute('data-url');
                let hreflangs = document.querySelectorAll('[hreflang]');

                if (button) {
                  const selected = document.querySelector('.country-select-option--selected');
                  if (selected) {
                    selected.dataset.code = countryCode;
                    selected.dataset.url = newURL;
                    selected.dataset.code = countryCode;
                    selected.innerHTML = dropdownOption.innerHTML;
                    selected.href = newURL;
                  }
                  button.href = newURL;
                  button.classList.remove('country-select-button--default');
                  button.addEventListener('click', () => {
                    buttonClick(button);
                  });

                } else {
                  hreflangs.forEach((hreflang) => {
                    let hrefLocale = hreflang.getAttribute('hreflang').toLowerCase();
                    if (hrefLocale == countryCode) {
                      newURL = hreflang.getAttribute('href');
                      return;
                    }
                  })
                  window.location.href = newURL;
                }
              }
            })
          })
        })

        document.addEventListener("click", function () {
          selectDropdown.classList.remove('is-open');
        });
      });
    }

    if (this.locationsPopup) {
      let button = this.locationsPopup.querySelector('.country-select-button--default');

      if (button) {
        button.addEventListener('click', (e) => {
          buttonClick(e, button, this.locationsPopup, this.body);
        });
      }

      let closeButton = this.locationsPopup.querySelector('.js-locations-popup-close');

      if (closeButton) {
        closeButton.addEventListener('click', () => {
          this.locationsPopup.style.display = 'none';
          this.body.style.overflow = "unset";
          document.cookie = 'location-popup=hidden; path=/; SameSite=Lax';
        });
      }
    }

    function buttonClick(e, button, location, body) {
      if (button && button.classList.contains('country-select-button--default')) {
        e.preventDefault();
        location.style.display = 'none';
        body.style.overflow = "unset";
        document.cookie = 'location-popup=hidden; path=/; SameSite=Lax';
      } else {
        document.cookie = 'site-redirect=' + button.href + '; path=/; SameSite=Lax';
      }
    }

    function getCookie(cookieName) {
      let cookie = {};
      document.cookie.split(';').forEach(function(el) {
        let [key,value] = el.split('=');
        cookie[key.trim()] = value;
      })
      return cookie[cookieName];
    }

    var redirect = getCookie("site-redirect");
    if (redirect) {
      window.location.href = redirect;
    }

    if (this.locationsPopup) {

      fetch(window.Shopify.routes.root + 'browsing_context_suggestions.json')
      .then((res) => {
        return res.json();
      })
      .then((location) => {
        let currentCountry = this.locationsPopup.dataset.currentCountry;
        let locationPopup = getCookie("location-popup");
        const countryName = location.country_name ? location.country_name : location.detected_values.country_name;

        if (typeof countryName != undefined && countryName != currentCountry && locationPopup != 'hidden') {
          this.locationsPopup.style.display = 'flex';
          this.body.style.overflow = "hidden";
        }
      })
    }
  }
}

new locationSelect();

// STOREFRONT API
window.API_VERSION = '2022-07';

window.storefrontFetch = payload => {
  return fetch(`https://${window.Shopify.shop}/api/${window.API_VERSION}/graphql.json`, {
    method: "POST",
    headers: {
      "Content-Type": "application/graphql",
      "X-Shopify-Storefront-Access-Token": window.API_ACCESS
    },
    body: payload
  })
}

// RETAILER BUTTONS DATALAYER
document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-retailer-name]');
  if (!btn) return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'retailer_button_click',
    retailer_name: btn.dataset.retailerName,
    retailer_url: btn.dataset.retailerUrl,
    product_id: btn.dataset.productId,
    product_sku: btn.dataset.productSku,
    product_title: btn.dataset.productTitle,
    market: btn.dataset.market,
    page_url: window.location.href
  });
});

// BUNDLES
class BundlePrice extends HTMLElement {
  constructor() {
    super();
    this.productHandles = this.dataset.productHandles.split(',');
    this.currencySymbol = this.dataset.currencySymbol;
    this.discount = parseFloat(this.dataset.discount) || 0;
    this.priceElement = this.querySelector('.js-price');
    this.comparePriceElement = this.querySelector('.js-compare-price');

    if (!window.API_ACCESS) return;

    this.loadPrice();
  }

  async loadPrice() {
    let totalOriginalPriceCents = 0;
    let totalDiscountedPriceCents = 0;

    // Function to fetch price for a single product by handle
    const bundleHandle = this.dataset.bundleHandle;

    const getProductData = async (productHandle) => {
      const payload = `{
        productByHandle(handle: "${productHandle}") {
          tags
          priceRange {
            minVariantPrice {
              amount
            }
          }
        }
      }`;

      const resp = await window.storefrontFetch(payload);

      if (!resp.ok) {
        throw new Error(`HTTP error! status: ${resp.status}`);
      }

      const data = (await resp.json()).data;

      if (!data || !data.productByHandle) {
        throw new Error(`Product not found: ${productHandle}`);
      }
      
      const price = parseFloat(data.productByHandle.priceRange.minVariantPrice.amount);
      const tags = data.productByHandle.tags;
      
      const discountTag = tags.find(tag => 
        tag.toLowerCase().includes(`${bundleHandle}_discount:`)
      );
      
      const discountPercentage = discountTag ? parseFloat(discountTag.split(':').pop()) : 0;
      
      return { price, discountPercentage };
    };

    // Fetch and add up prices for all product handles
    for (const productHandle of this.productHandles) {
      const { price, discountPercentage } = await getProductData(productHandle);
      
      const priceCents = Math.round(price * 100);
      totalOriginalPriceCents += priceCents;
      
      const discountMultiplier = (100.00 - discountPercentage) / 100.00;
      const discountedPriceCents = Math.round(priceCents * discountMultiplier);
      
      totalDiscountedPriceCents += discountedPriceCents;
    }

    const finalComparePrice = (totalOriginalPriceCents / 100).toFixed(2);
    const finalDiscountedPrice = (totalDiscountedPriceCents / 100).toFixed(2);

    // Update the DOM elements
    if (this.priceElement) {
      this.priceElement.textContent = this.currencySymbol + finalDiscountedPrice;
      this.priceElement.classList.remove('loading');
    }

    if (this.comparePriceElement && this.discount > 0) {
      this.comparePriceElement.textContent = this.currencySymbol + finalComparePrice;
      this.comparePriceElement.classList.remove('hidden');
      this.priceElement.classList.add('product-price--sale');
    }
  }
}

customElements.define('bundle-price', BundlePrice);

if (!customElements.get('discount-code')) {
  class DiscountCode extends HTMLElement {
    constructor() {
      super();

      this.isMiniCartForm = this.getAttribute('data-mini-cart');
      this.appliedValidCodes = this.getAttribute('data-applied-valid-codes') ? this.getAttribute('data-applied-valid-codes').split(',') : '';

      this.listeners();
    }

    listeners() {
      this.form = this.querySelector('.js-discount-code-form');
      this.input = this.querySelector('.js-discount-code-input');

      if (this.form && this.input) {
        this.form.addEventListener('submit', (e) => {
          e.preventDefault();
          this.onDiscountCodeSubmit(this.input.value);
        })
      }

      this.errorMessage = this.querySelector('.js-discount-code-error');

      if (this.errorMessage) {
        this.handleErrorMessage();
      }
      
      this.clearCodes = this.querySelector('.js-discount-code-clear');

      if (this.clearCodes) {
        this.clearCodes.addEventListener('click', () => {
          if (this.isMiniCartForm) sessionStorage.setItem('showPopoutCart', 'true');

          fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              discount: ''
            })
          })
          .then(res => res.json())
          .then(cart => {
            window.location = `${window.shopUrl}/discount/clear?redirect=${window.location.pathname}`;
          });

          
        })
      }
    }

    handleErrorMessage() {
      const error = this.querySelector('.js-discount-code-error');

      if (!error) return;

      const appliedCode = sessionStorage.getItem('discountCode');
      
      if (appliedCode && !this.appliedValidCodes.includes(appliedCode.toLowerCase())) {
        error.innerHTML = window.cartStrings.discountCodeError.replace('[code]', appliedCode);
        error.classList.remove('discount-code__error--hidden');
      }

      sessionStorage.removeItem('discountCode');
    }

    onDiscountCodeSubmit(code) {
      const trimmedCode = code.trim();

      if (trimmedCode.length === 0) return;

      sessionStorage.setItem('discountCode', trimmedCode);

      if (this.isMiniCartForm) sessionStorage.setItem('showPopoutCart', 'true');
      
      window.location = `${window.shopUrl}/discount/${trimmedCode}?redirect=${window.location.pathname}`;
    }
  }

  customElements.define('discount-code', DiscountCode);
}

/* Move each swatch's colour name out of its <label> into a transparent hover overlay so screen readers announce it on hover. */
(function () {
  'use strict';

  function enhanceSwatch(swatch) {
    if (swatch.querySelector('.product-swatch__a11y')) return;

    const span = swatch.querySelector('.product-swatch__icon span');
    if (!span) return;

    const name = (span.getAttribute('aria-label') || span.textContent || '').trim();
    if (!name) return;

    const control = swatch.querySelector('input[type="radio"], button, modal-show, a[href]');

    // Plain transparent text so NVDA's default "text under mouse" reads it without extra settings.
    span.className = 'product-swatch__a11y';
    span.removeAttribute('role');
    span.removeAttribute('aria-label');
    span.textContent = name;
    swatch.appendChild(span); // out of the <label> so hover no longer maps to the radio

    // Keep the control named now that the label lost its text.
    if (control && !control.getAttribute('aria-label')) {
      control.setAttribute('aria-label', name);
    }

    if (control) {
      span.addEventListener('click', () => control.click());
    }
  }

  function scanSwatches() {
    document.querySelectorAll('.product-swatch').forEach(enhanceSwatch);
  }

  let scanTimer;
  function scheduleSwatchScan() {
    clearTimeout(scanTimer);
    scanTimer = setTimeout(scanSwatches, 100);
  }

  scanSwatches();
  new MutationObserver(scheduleSwatchScan).observe(document.body, { childList: true, subtree: true });
})();
